import Vue from 'vue'
import App from './App.vue'
import VueCurrencyInput from 'vue-currency-input'
import {SeatingChartController} from "../../shared_components/seating-chart-2/SeatingChartController";
import {TicketSelectionMapController} from "./TicketSelectionMapController";
import {IEventListener} from "../../shared_components/seating-chart-2/IEventListener";




const pluginOptions = { /* see config reference */};
Vue.use(VueCurrencyInput, pluginOptions);
// Vue.component('v-select', vSelect);
Vue.config.productionTip = false;
let controller: SeatingChartController = new TicketSelectionMapController();

let vueApp = new Vue({
    beforeMount() {
        // const companyId: string | null = this.$el.getAttribute('data-company-id');
        const eventId: string | null = this.$el.getAttribute('data-event-id');
        const subscriptionId: string | null = this.$el.getAttribute('data-subscription-id');
        const titleLeft: string | null = this.$el.getAttribute('data-title-left');
        const titleRight: string | null = this.$el.getAttribute('data-title-right');
        const readonly: boolean | true = (this.$el.getAttribute('data-readonly') !== "False");

        let childElement = this.$el.firstElementChild;
        if (childElement) {
            this.$data.seatPlan = childElement.innerHTML;
        }

        this.$data.id = eventId ? parseInt(eventId, 10) : subscriptionId? parseInt(subscriptionId, 10) : 0;
        this.$data.mode = eventId? ReservationMode.EventMode: ReservationMode.SubscriptionMode;
        this.$data.map = controller;
        this.$data.titleLeft = titleLeft;
        this.$data.titleRight = titleRight;
        this.$data.isReadOnly = readonly;
    },
    mounted() {
        let xx: any = this.$children[0];
        controller.AddEventListener(<IEventListener>xx);
        let svg = document.getElementById('seatplan_svg') as HTMLImageElement;
        let div = document.getElementById("seatplan_div") as HTMLDivElement;
        controller.init(svg, div);
    },
    render: (createElement) => {
        const c: any = {
            props: vueApp.$data,
        };
        return createElement(App, c);
        // context.parent.$root.$props['eventid'] = context.props['data-eventid'];
        // return createElement(App, context.data, context.children);
    },
});
let x = vueApp.$mount('#app');

(<any>window).app = vueApp.$children[0];

